<template>
    <div class="nav">
        <img src="../../assets/demonstration/333333.png" width="1027px" height="220px"
             style="float:right;margin-top: -1px">
        <p class="mtcal">产品演示<span class="fontSize">&emsp;业内领先的区块链全生态服务提供商</span></p>
        <div class="btnBox">
            <el-button class="btn" @click="goabout()">免费咨询</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "top-picture.vue",
      data(){
          return{

          }
      },
      methods:{
        goabout(){
          this.$router.push({
            name: 'about'
          })
        }
      }
    }
</script>

<style scoped lang="scss">
.nav {
  min-width: 1480px;
  margin-top: 78px;
  height: 219px;
  width: 100%;
  background-color: #F5F9FC;
}

.fontSize {
  width: 450px;
  height: 28px;
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2D3036;
  line-height: 28px;
  position: absolute;
  top: 140px;
}

.mtcal {
  width: 180px;
  height: 63px;
  font-size: 37px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #282B31;
  line-height: 63px;
  margin-left: 15.5%;
  padding-top: 44px;
}

.btnBox {
  margin-top: 32px;
  margin-left: 15.5%;
}

.btn {
  width: 139px;
  height: 39px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 16px;
  background: #0069FD;
  border-radius: 20px;
  margin-top: 25px;

}
</style>
